export default "/_next/static/images/img3-6ea3e6a039be246074f7582cf1deff1c.png";